import { handleCodeNavRequest } from '../../code-nav/handle-code-nav-request.js';
import type { ApiToBridgeFileBrowserCodeNavMessage } from '../../types/api-to-bridge-messages.js';
import type { MessageHandlerDeps } from '../message-handler-deps.js';

export function handleFileBrowserCodeNavMessage(
  msg: ApiToBridgeFileBrowserCodeNavMessage,
  { getWs, e2ee, sessionWorktreeManager }: MessageHandlerDeps,
): void {
  if (typeof msg.id !== 'string' || typeof msg.path !== 'string') return;
  const socket = getWs();
  if (!socket) return;
  handleCodeNavRequest(
    {
      id: msg.id,
      type: 'code_nav',
      op:
        msg.op === 'references'
          ? 'references'
          : msg.op === 'symbols'
            ? 'symbols'
            : msg.op === 'definitions'
              ? 'definitions'
              : 'definition',
      path: msg.path,
      line: typeof msg.line === 'number' ? msg.line : 1,
      column: typeof msg.column === 'number' ? msg.column : 0,
      sessionId: msg.sessionId,
    },
    socket,
    e2ee,
    sessionWorktreeManager,
  );
}
